import { USER_EMAIL_ERR_MSG_LENGTH } from 'constants/validMsg.js';
import { USER_EMAIL_ERR_MSG_SYMBOL } from 'constants/validMsg.js';
import { USER_EMAIL_ERR_MSG_SPACE } from 'constants/validMsg.js';
import { USER_EMAIL_ERR_MSG_FORMAT } from 'constants/validMsg.js';

/**
 * @function validateEmail
 * @date June 29, 2023
 * @param {string} value
 * @returns {Object} result
 * @returns {boolean} result.isErr
 * @returns {string} result.errMsg
 */
const validateEmail = (value) => {
	let result = { isErr: false, errMsg: '' };

	if (value.length === 0) {
		return result;
	} else if (value.length < 10 || value.length > 100) {
		result = { isErr: true, errMsg: USER_EMAIL_ERR_MSG_LENGTH };
		return result;
	} else if (value.length > 10 || value.length < 100) {
		const symbolCount = (value.match(/[!$#%^&*()+|~=`'{}[\]:";<>?,/]/g) || []).length;
		const spaceCount = (value.match(/[\s]/g) || []).length;
		const regex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
		const validated = regex.test(value);

		if (symbolCount > 0) {
			result = { isErr: true, errMsg: USER_EMAIL_ERR_MSG_SYMBOL };
			return result;
		} else if (spaceCount > 0) {
			result = { isErr: true, errMsg: USER_EMAIL_ERR_MSG_SPACE };
			return result;
		} else if (!validated) {
			result = { isErr: true, errMsg: USER_EMAIL_ERR_MSG_FORMAT };
			return result;
		} else {
			return result;
		}
	}
};

export default validateEmail;
